import { useState } from "react";
import axios, { API } from "../../api";

/** Reset password landing — reads token from URL hash, user enters new password. */
export function ResetPasswordScreen({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    if (!token) { setError("Missing reset token"); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (password !== confirm) { setError("Passwords don't match"); return; }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      try { window.history.replaceState(null, "", window.location.pathname); } catch (_) {}
      setDone(true);
      setTimeout(() => onDone?.(), 2200);
    } catch (err) {
      setError(err?.response?.data?.detail || "Reset failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <div className="init-screen">
        <div className="init-content auth-form" data-testid="reset-password-screen">
          {!done ? (
            <>
              <h2 className="auth-title">Set a new password</h2>
              <form onSubmit={submit}>
                <input
                  type="password"
                  className="init-input"
                  placeholder="New password (min 8 chars)"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="reset-new-password-input"
                  autoFocus
                />
                <input
                  type="password"
                  className="init-input"
                  placeholder="Confirm password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  data-testid="reset-confirm-password-input"
                />
                {error && <div className="error-message" data-testid="reset-error">{error}</div>}
                <button
                  type="submit"
                  className="init-btn"
                  disabled={submitting || !password || !confirm}
                  data-testid="reset-submit-btn"
                >
                  {submitting ? "Resetting..." : "Reset password"}
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ fontSize: "3rem", textAlign: "center" }}>✨</div>
              <h2 className="auth-title">Password reset</h2>
              <p style={{ opacity: 0.85 }}>You can sign in with your new password now.</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
